// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Bgm4p","Tag_theme_contrast":"_5qSFP","Tag_theme_gray":"MMlbf","Tag_theme_more":"bTAaw","Tag_active":"_20orC"};